import { forwardRef } from 'react'
import * as S from './styles'
import NewModuleTag from '@/components/LandingPage/NewModuleTag'
import { PAGE_PATHS } from '@/services/paths'
import { useTranslation } from 'react-i18next'
import DOMPurify from 'dompurify'

const ContentItem = forwardRef(function ContentItem(
  { data, parentIndex, index },
  ref
) {
  const { t } = useTranslation()

  if (!data) return null

  const title = t(data.title)
  const subtitle = t(data.subtitle)
  const btnText = t(data.buttonText)
  const sanitizedText = DOMPurify.sanitize(t(data.text))

  return (
    <S.ContentItemContainer
      ref={ref}
      id={`content-${parentIndex}-${index}`}
      style={{ display: 'none' }}
    >
      <S.ContentItemImgContainer className="mobile-only">
        <video preload="auto" playsInline loop muted autoPlay>
          <source type="video/webm" src={`${data.image}.webm`} />
          <source type="video/mp4" src={`${data.image}.mp4`} />
          Your browser does not support the video tag.
        </video>

        <S.ContentItemTextContainer>
          {data.newUntil && <NewModuleTag expDate={data.newUntil} />}
          <h3>{title}</h3>
          <h4>{subtitle}</h4>
          <p
            dangerouslySetInnerHTML={{
              __html: sanitizedText
            }}
          />
          <a
            href={`${PAGE_PATHS.contents}?section=${parentIndex}&subsection=${index}`}
            id={`btn_contents_${parentIndex}_${index}`}
            className="btn lg round shadow"
          >
            <span>{btnText}</span>
            <span className="material-icons-round">arrow_forward</span>
          </a>
        </S.ContentItemTextContainer>
      </S.ContentItemImgContainer>

      <S.ContentItemDesktopWrapper>
        <S.ContentItemTextContainer>
          {data.newUntil && <NewModuleTag expDate={data.newUntil} />}
          <h3>{title}</h3>
          <h4>{subtitle}</h4>
          <p
            dangerouslySetInnerHTML={{
              __html: sanitizedText
            }}
          />
          <a
            href={`${PAGE_PATHS.contents}?section=${parentIndex}&subsection=${index}`}
            id={`btn_contents_${parentIndex}_${index}`}
            className="btn lg round shadow"
          >
            <span>{btnText}</span>
            <span className="material-icons-round">arrow_forward</span>
          </a>
        </S.ContentItemTextContainer>

        <S.ContentItemImgContainer className="desktop-only">
          <video preload="auto" playsInline loop muted autoPlay>
            <source type="video/webm" src={`${data.image}.webm`} />
            <source type="video/mp4" src={`${data.image}.mp4`} />
            Your browser does not support the video tag.
          </video>
        </S.ContentItemImgContainer>
      </S.ContentItemDesktopWrapper>
    </S.ContentItemContainer>
  )
})

ContentItem.displayName = 'ContentItem'

export default ContentItem
